import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { foreignFinancialInterestOptions, foreignInterestCoOwnerOptions } from 'constants/enums/foreignActivityOptions';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { DATE_IN_THE_PAST } from 'constants/errors';
import { ForeignActivitiesFutureItemModel } from '../types';
// this validator is used in PVQ only - all fields apply to pvq only
export const foreignActivitiesFutureItemValidator: ValidateJSModel<ForeignActivitiesFutureItemModel> = {
  PrimaryPersonType: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignInterestCoOwnerOptions,
        },
      },
    },
  }),

  Name: (value, attributes, attributeName, options) => {
    if (attributes?.PrimaryPersonType?.value === 'Dependent children') {
      return {
        presence: true,
        model: { validator: nameModelValidator },
      };
    }
    return {};
  },
  InterestType: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignFinancialInterestOptions,
        },
      },
    },
  }),
  OtherExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.InterestType?.value?.includes?.('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Country: { hasValue: true, country: { excludeUnitedStates: true } },
  ExpectedDate: (value, attributes, attributeName, options) => ({
    date: {
      requireDay: false,
      earliest: DEFAULT_LATEST,
      tooEarly: DATE_IN_THE_PAST,
    },
  }),
  Reason: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
};
